import React from "react";

const EthicalSourcing = () => {
  const principles = [
    {
      id: "01",
      title: "Informed Consent",
      description:
        "Voluntary, research-specific consent covering storage, testing, and global data sharing.",
    },
    {
      id: "02",
      title: "IRB Approval",
      description:
        "All collection protocols are reviewed and approved by qualified Institutional Review Boards.",
    },
    {
      id: "03",
      title: "Regulatory Compliance",
      description:
        "Full adherence to HIPAA, Common Rule, and FDA guidance for specimen-based research.",
    },
    {
      id: "04",
      title: "International Standards",
      description:
        "Aligned with ISBER Best Practices and the Declaration of Helsinki principles.",
    },
  ];

  return (
    <section className="bg-white py-8 md:py-16 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-[1800px] mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076] mb-2">
            Ethical Sourcing Principles
          </h2>
          <p className="text-[14px] md:text-[18px] xl:text-[24px]">
            Foundation of trust for human subjects research
          </p>
        </div>

        {/* Principles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((principle) => (
            <div
              key={principle.id}
              className="bg-[#183076] text-white p-8 rounded-2xl flex flex-col h-full transition-transform hover:scale-105 duration-300"
            >
              <span className="text-[24px] 2xl:text-[30px] font-bold mb-4 opacity-90">
                {principle.id}
              </span>
              <h3 className="text-[24px] 2xl:text-[30px] font-bold mb-[100px] leading-tight">
                {principle.title}
              </h3>
              <p className="text-[14px] md:text-[18px] xl:text-[24px] leading-relaxed text-justify mt-auto">
                {principle.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EthicalSourcing;
